import { render, staticRenderFns } from "./CampaignCardSkeleton.vue?vue&type=template&id=aedc6ef6&scoped=true&"
import script from "./CampaignCardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CampaignCardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCardSkeleton.vue?vue&type=style&index=0&id=aedc6ef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aedc6ef6",
  null
  
)

export default component.exports